import timePeriodList from "./time-period";
import decisionTypeList from "./decision-type";


export default [...timePeriodList, ...decisionTypeList];